import DetailCardBody from '@/common/components/DetailCard/DetailCardBody';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard';
import MainLayout from '@/common/components/layouts/MainLayout';
import TimeSetModal, {
  SetTimeFormType,
} from '@/common/components/scheduleVisitListComponent/TimeSetModal';
import LoadingPage from '@/common/pages/LoadingPage';
import PropertyScheduleVisit from '@/common/pages/scheduleVisit/ScheduleVisit';
import { useCreateTimeSetQueryOptions } from '@/common/queries/createTimeSet/createTimeSetQueryOptions';
import { FileTypeConst } from '@/common/types/Files.type';
import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import FileDetailCardAction from '@/modules/FileDetail/components/action/myFileActions/FileDetailCardAction';
import EntryTabs from '@/modules/FileDetail/components/entryTabs/EntryTabs.tsx';
import RenderAlert from '@/modules/FileDetail/components/renderAlert/RenderAlert.tsx';
import RenderIcon from '@/modules/FileDetail/components/renderIcon/RenderIcon.tsx';
import { fileEntryQueryOptions } from '@/modules/FileDetail/queries/fileEntry/fileEntryQueryOptions.ts';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default () => (
  <MainLayout title="صفحه پرونده" header="titleHeader">
    <FileDetail />
  </MainLayout>
);

const FileDetail = () => {
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const {
    data,
    isError,
    isPending,
    refetch: getFileDetail,
  } = useQuery(fileEntryQueryOptions(id!));

  const fileType: FileTypeConst = data?.file_type?.const!;
  const { mutate } = useCreateTimeSetQueryOptions();
  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }

  const onSubmitForm = (data: SetTimeFormType) => {
    mutate(
      {
        data: {
          adjuster_visit_date: convertPersianToGregorian(
            data.adjuster_visit_date,
          ),
          adjuster_visit_time: data.adjuster_visit_time,
          visit_location: data.visit_location,
          visit_location_phi: null,
          visit_location_lambda: null,
        },
        id: id!,
      },
      {
        onSuccess: () => {
          setOpen(false);
          getFileDetail();
        },
      },
    );
  };

  return (
    <Box paddingTop="54px">
      {fileType === 'property' ? (
        <PropertyScheduleVisit
          open={open}
          setOpen={setOpen}
          enableGetFileList={open}
        />
      ) : (
        <TimeSetModal
          open={open}
          closeModal={() => setOpen(false)}
          onSubmitForm={(data) => {
            onSubmitForm(data);
          }}
        />
      )}

      <MainDetailCard>
        <Box position="relative" p="24px">
          <Box
            position="absolute"
            top="0"
            left="50%"
            transform="translate(-50%,-50%)"
            mt="8px"
            border="2px solid white"
            borderRadius="50%"
          >
            <RenderIcon fileType={data?.file_type?.const!} />
          </Box>
        </Box>
        <DetailCardBody>
          <DetailCardItems
            backgroundColor="pink-1"
            items={data?.detailCardItems ?? []}
          />
        </DetailCardBody>
        <FileDetailCardAction
          action={data?.actions!}
          onClick={() => setOpen(true)}
        />
      </MainDetailCard>

      <Box>
        <RenderAlert fileType={data.file_type.const} />
      </Box>
      <EntryTabs />
    </Box>
  );
};
